import React, { useState } from 'react';
import Button from '../Button';
import { StyledDeleteChatModal } from './DeleteProjectModal.style';
import projectService from '../../services/projectService';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import Toast from '../Toast';

const DeleteProjectModal = ({ onClose, refetch, isEdit }) => {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: async e => {
      return await projectService.deleteProject(e);
    },
    onSuccess: response => {
      Toast({ type: 'success', message: response.detail });
      queryClient.invalidateQueries({ queryKey: ['get_all_projects'] });
      onClose();
      console.log(response);
    },
    onError: err => {
      console.log(err);
      Toast({ type: 'error', message: err.detail });
    },
  });

  return (
    <StyledDeleteChatModal>
      <h2 className="desc">Are you sure you want to delete</h2>
      <div className="btn-holder">
        <Button width="136px" variant="secondary-outline" onClick={() => onClose()}>
          Cancel
        </Button>
        <Button width="150px" onClick={() => mutation.mutate(isEdit?.project_id)} loader={mutation.isPending}>
          Delete
        </Button>
      </div>
    </StyledDeleteChatModal>
  );
};

export default DeleteProjectModal;
